import { useNavigate } from 'react-router'
import React from 'react'
import Assignment from '@mui/icons-material/Assignment'
import AccountTree from '@mui/icons-material/AccountTree'
import People from '@mui/icons-material/People'
import PersonAdd from '@mui/icons-material/PersonAdd'
import CalendarToday from '@mui/icons-material/CalendarToday'
import Event from '@mui/icons-material/Event'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import {
  SupportHomePageContainer,
  SupportHomePageItem,
  TILE_COLORS,
  TileIconContainer,
  TileText,
} from 'src/supportPortal/views/home/styledComponents'
import useServerAuth from 'src/customHooks/useServerAuth'

export default function PatientsNavPage() {
  const navigate = useNavigate()
  const { allRolesInBoolean } = useServerAuth()
  
  return (
    <>
      <SupportHeader heading={'Patients'} showBackButton />
      <SupportHomePageContainer>
        <SupportHomePageItem 
          otherColor={TILE_COLORS.therapyActions}
          onClick={() => navigate('/support-home/patient-management/therapy-actions')}
        >
          <TileIconContainer>
            <Assignment />
          </TileIconContainer>
          <TileText>Therapy Actions</TileText>
        </SupportHomePageItem>
        {(allRolesInBoolean.isL2TherapySupport ||
          allRolesInBoolean.isL3TherapySupport ||
          allRolesInBoolean.isClinicSuccessManager ||
          allRolesInBoolean.isClinicSuccessAdmin ||
          allRolesInBoolean.isAdmin) && (
          <SupportHomePageItem
            otherColor={TILE_COLORS.customCommunications}
            onClick={() => navigate('/support-home/patient-management/care-orchestration')}
          >
            <TileIconContainer>
              <AccountTree />
            </TileIconContainer>
            <TileText>Care Orchestration</TileText>
          </SupportHomePageItem>
        )}
        {(allRolesInBoolean.isL2TherapySupport ||
          allRolesInBoolean.isL3TherapySupport ||
          allRolesInBoolean.isClinicSuccessManager) && (
          <SupportHomePageItem
            otherColor={TILE_COLORS.patientList}
            onClick={() => navigate('/support-home/patient-management/list')}
          >
            <TileIconContainer>
              <People />
            </TileIconContainer>
            <TileText>Patient List</TileText>
          </SupportHomePageItem>
        )}
        {(allRolesInBoolean.isL2TherapySupport ||
          allRolesInBoolean.isL3TherapySupport ||
          allRolesInBoolean.isClinicSuccessManager ||
          allRolesInBoolean.isClinicSuccessAdmin) && (
          <SupportHomePageItem
            otherColor={TILE_COLORS.applicants}
            onClick={() => navigate('/support-home/patient-management/prospects')}
          >
            <TileIconContainer>
              <PersonAdd />
            </TileIconContainer>
            <TileText>Patient Prospects</TileText>
          </SupportHomePageItem>
        )}
        {(allRolesInBoolean.isL1TherapySupport ||
          allRolesInBoolean.isL2TherapySupport ||
          allRolesInBoolean.isL3TherapySupport) && (
          <SupportHomePageItem 
            otherColor={TILE_COLORS.therapyScheduled}
            onClick={() => navigate('/support-home/patient-management/therapy-scheduled-patients')}
          >
            <TileIconContainer>
              <CalendarToday />
            </TileIconContainer>
            <TileText>Therapy Scheduled Patients</TileText>
          </SupportHomePageItem>
        )}
        {(allRolesInBoolean.isL1TherapySupport ||
          allRolesInBoolean.isL2TherapySupport ||
          allRolesInBoolean.isL3TherapySupport) && (
          <SupportHomePageItem 
            otherColor={TILE_COLORS.consultationScheduled}
            onClick={() => navigate('/support-home/patient-management/consultation-scheduled-patients')}
          >
            <TileIconContainer>
              <Event />
            </TileIconContainer>
            <TileText>Consultation Scheduled Patients</TileText>
          </SupportHomePageItem>
        )}
      </SupportHomePageContainer>
    </>
  )
}
